import type { FormFieldProps } from "@octopusdeploy/design-system-octopus-components";
import type { TagSetResource } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import type { DoBusyTask } from "~/components/DataBaseComponent/DataBaseComponent";
import * as tagSets from "~/components/tagSets";
import { TagMultiSelect } from "./TagMultiSelect";
interface RunbookTagMultiSelectProps extends FormFieldProps<string[]> {
    doBusyTask: DoBusyTask;
    items?: TagSetResource[] | (() => TagSetResource[]);
    autoFocus?: boolean;
    disableCloseOnSelected?: boolean;
}
export const RunbookTagMultiSelect: React.FC<RunbookTagMultiSelectProps> = (props) => {
    return <TagMultiSelect {...props} getAll={() => tagSets.getAllByScopes(["Runbook"])} groupByTagSet={tagSets.groupByTagSet} flattenGroup={tagSets.flattenGroup}/>;
};
RunbookTagMultiSelect.displayName = "RunbookTagMultiSelect"
